import React from 'react';
import getPredefinedScriptIcon from '../../../../services/mini/getPredefinedScriptIcon';

const scriptIconsMap = {
    bitcoin: 'script-bitcoin',
    calculator: 'script-calculator',
    yoda: 'script-yoda',
    weather: 'script-weather',
    calendar: 'script-calendar',
    coffee: 'script-coffee',
    customer_feedback: 'script-customer-feedback',
    navigate: 'script-directions',
    food_ordering: 'script-food-ordering',
    hello: 'script-hello',
    jeopardy_game: 'script-jeopardy',
    jeopardy_data: 'script-jeopardy',
    news: 'script-news',
    sap_deliveries_data: 'script-sap',
    sap_deliveries_logic: 'script-sap',
    smalltalk: 'script-small-talk',
};
class PredefinedScriptItemTile extends React.PureComponent {
    render() {
        const { name, title, unselectScript } = this.props;

        return <div
            className="predefined-script-item-tile"
            onClick={() => unselectScript(title)}>
            <div className="predefined-script-item-tile_icon">
                <i className={`icon icon-${getPredefinedScriptIcon(name)}`} />
            </div>
            <div
                className="predefined-script-item-tile_name"
                title={title}>
                {title}
            </div>
        </div>;
    }
}

export default PredefinedScriptItemTile;
